import axios from '../helpers/axios';
import * as errors from '../errors';
import { accessRulesAction, fetchPresetsAction, fetchDomainsSuccess } from '../modules/actions';
import { changeModalState } from '../modules/actions/modals';
import type { AppThunk, Notify } from '../typings/redux';
import { getTranslationKey } from '../modules/utils';

export const getDomains = (): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const res = await axios.get('/api/domains');
    dispatch({ type: 'SET_ALL_DOMAINS', payload: res.data });
  } catch (e) {
    errors.handleErrorWithRedirectIfNotAuth(e);
  }
};

export const createDomain =
  (domain: any, notify: Notify): AppThunk<Promise<void>> =>
  async (dispatch, getState: any) => {
    try {
      const { domainsNew } = getState();

      const res = await axios.post('/api/domain/', domain);
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('successfullyCreated'),
        status: 'success',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
      dispatch({ type: 'ADD_DOMAIN', payload: res.data });
      dispatch(accessRulesAction());
      dispatch(fetchDomainsSuccess([...domainsNew.items, res.data]));
    } catch (e: any) {
      const { status } = e?.response ?? {};

      switch (status) {
        case 402:
          dispatch(
            changeModalState({
              key: 'upgradeModal',
              state: true,
              desiredAction: 'domains',
              modalData: { addon: 'domains' }
            })
          );
          break;
        case 422:
          notify({
            title: getTranslationKey('error'),
            message: getTranslationKey('generalError'),
            status: 'error',
            position: 'top-center',
            dismissible: true,
            dismissAfter: 15000
          });
          break;
        default:
          errors.handleErrorWithRedirectIfNotAuth(e);
      }
    }
  };

export const deleteDomain =
  (domain_id: string, notify: Notify): AppThunk<Promise<void>> =>
  async (dispatch, getState: any) => {
    try {
      const { domainsNew } = getState();

      await axios.delete('/api/domain/', { params: { domain_id } });
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('successfullyDeleted'),
        status: 'info',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
      dispatch({ type: 'REMOVE_DOMAIN', payload: domain_id });
      dispatch(accessRulesAction());

      const newList = domainsNew.items.filter((item: { _id: string }) => item._id !== domain_id);
      dispatch(fetchDomainsSuccess(newList));

      dispatch(fetchPresetsAction());
    } catch (e: any) {
      if (e?.response?.status === 428) {
        notify({
          title: getTranslationKey('error'),
          message: getTranslationKey('customDomains.deleteImprintErrorInUse'),
          status: 'error',
          position: 'top-center',
          dismissible: true,
          dismissAfter: 10000
        });
      } else errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };

export const updateDomain =
  (domain: any): AppThunk<Promise<void>> =>
  async () => {
    try {
      await axios.put('/api/domain/', { params: domain });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e);
    }
  };
